import ProjectIcon from '../assets/icons/project-management.png';
import WorkersIcon from '../assets/icons/coworkers.png';
import MarkersIcon from '../assets/icons/pin.png';
import OrdersIcon from '../assets/icons/project-management.png';
import UsersIcon from '../assets/icons/users.png';
import NotificationIcon from '../assets/icons/notification-bell.png';
import PackgesIcon from '../assets/icons/box.png';
import SubPackgesIcon from '../assets/icons/boxes.png';
import MarketingsIcon from '../assets/icons/placeholder.png';
import ExperincesIcon from '../assets/icons/experience.png';
import PlacesIcon from '../assets/icons/supported-places.png';

const sidebar_menu = [
    {
        id: 1,
        icon: ProjectIcon,
        path: '/dashboard',
        title: 'معلومات عنا',
    },
    {
        id: 2,
        icon: WorkersIcon,
        path: '/dashboard/workers',
        title: 'العاملون لدينا',
    },
    {
        id: 3,
        icon: OrdersIcon,
        path: '/dashboard/orders',
        title: 'الطلبات',
    },
    {
        id: 4,
        icon: MarkersIcon,
        path: '/dashboard/markers',
        title: 'العلامات',
    },
    {
        id: 5,
        icon: PackgesIcon,
        path: '/dashboard/packages',
        title: 'بكجاتنا',
    },
    {
        id: 6,
        icon: SubPackgesIcon,
        path: '/dashboard/subpackages',
        title: 'بكجات شركاؤنا',
    },
    {
        id: 7,
        icon: MarketingsIcon,
        path: '/dashboard/marketings',
        title: 'شركاء التسويق',
    },
    {
        id: 8,
        icon: NotificationIcon,
        path: '/dashboard/notifications',
        title: 'الاشعارات',
    },
    {
        id: 9,
        icon: ExperincesIcon,
        path: '/dashboard/experiences',
        title: 'التجارب',
    },
    {
        id: 10,
        icon: PlacesIcon,
        path: '/dashboard/places',
        title: 'الاماكن',
    },
    {
        id: 11,
        icon: UsersIcon,
        path: '/dashboard/users',
        title: 'المستخدمين',
    },
   
]

export default sidebar_menu;